import { createAction, nanoid, AnyAction, ThunkAction } from '@reduxjs/toolkit';
import { Notification, NotificationType } from './types';

/**
 * Action that inserts a new UI notification (toast) to the state.
 */
export const insertNotification = createAction(
  'notifications/insertNotification',
  (type: NotificationType, message: string) => {
    const id = nanoid();
    const timestamp = new Date().getTime();
    const notification: Notification = { id, type, message, timestamp };
    return {
      payload: notification,
    };
  },
);

/**
 * Action that removes a UI notification (toast) from the state.
 */
export const dismissNotification = createAction<string>('notifications/dismissNotification');

/**
 * Thunk that shows an UI notification (toast), automatically
 * dismissing "info" level notifications after a time period.
 */
export function showNotification(
  type: NotificationType,
  message: string,
): ThunkAction<Notification, unknown, unknown, AnyAction> {
  return (dispatch) => {
    const { payload: notification } = dispatch(insertNotification(type, message));
    // Automatically hide info and success notifications after 10 seconds
    const autohidingTypes: NotificationType[] = ['info', 'success'];
    if (autohidingTypes.includes(notification.type)) {
      setTimeout(() => {
        dispatch(dismissNotification(notification.id));
      }, 10000);
    }
    return notification;
  };
}
